import React, { useState, useEffect } from "react";
import "./GetCode.css";
import styles from "./Login.module.scss";
import LoginPic from "../../Assets/img/Login.svg";
import GetCode from "../../Assets/img/code.svg";
import axios from "axios";
import Home from "../Home/Home";
import swal from "sweetalert";
import Loader from "react-loader-spinner";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import ReactCodeInput from "react-verification-code-input";
import { TbEdit } from "react-icons/tb";
import { useNavigate } from "react-router-dom";

function Login() {
  const navigate = useNavigate();
  const [sendCode, setSendCode] = useState(false);
  const [loader, setLoader] = useState(false);
  const [phone, setPhone] = useState("");
  const [code, setCode] = useState("");

  useEffect(() => {
    if (localStorage.getItem("token") !== null) {
      navigate("/home");
    }
  }, [navigate]);

  // اگر کاربر لاگین کرده باشه
  if (localStorage.getItem("token") !== null) {
    return <Home />;
  }

  const onChangePhone = (e) => {
    setPhone(e.target.value);
  };

  const onChangeCode = (value) => {
    setCode(value);
  };

  const getCode = () => {
    setLoader(true);

    if (phone.length !== 11) {
      swal({
        title: "!خطا",
        text: "!فیلد شماره تماس باید 11 رقم باشد",
        icon: "error",
        button: "!باشه",
      });
      setLoader(false);
      return;
    }

    axios
      .post("https://arianaapp.arianaapply.com/api/V1/login-code", {
        phone: phone,
      })
      .then((res) => {
        console.log(res);
        if (res.data.status === 401) {
          setLoader(false);
          swal({
            title: "!خطا",
            text: "!حساب کاربری با این شماره یافت نشد",
            icon: "error",
            button: "!باشه",
          });
        } else {
          setSendCode(true);
          setLoader(false);
        }
      })
      .catch((error) => {
        console.log(error.response);
        setLoader(false);
      });
  };

  const login = () => {
    setLoader(true);

    if (code.length === 0) {
      swal({
        title: "!خطا",
        text: "!فیلد کد را پر کنید",
        icon: "error",
        button: "!باشه",
      });
      setLoader(false);
      return;
    }

    axios
      .post("https://arianaapp.arianaapply.com/api/V1/login", {
        phone: phone,
        password: code,
      })
      .then((response) => {
        console.log(response);
        if (response.data.status === 500) {
          swal({
            title: "!خطا",
            text: "!کد وارد شده نامعتبر است",
            icon: "error",
            button: "!باشه",
          });
          setLoader(false);
        } else {
          localStorage.setItem("token", response.data.api_token);
          setLoader(false);
          navigate("/home");
        }
      })
      .catch((err) => {
        console.log(err);
        setLoader(false);
      });
  };

  return (
    <>
      {sendCode ? (
        <div className={styles.getCode}>
          <div className={styles.getCodeBody}>
            <img src={GetCode} alt="" />

            <div className={styles.getCodeTitle}>
              <h2>کد اعتبار سنجی</h2>
            </div>

            <div className={styles.getCodeText}>
              <p>
                کد ورود شما به شماره <strong>{phone}</strong> ارسال شد
              </p>
            </div>

            <div
              className={styles.editPhone}
              onClick={() => window.location.reload()}
            >
              <TbEdit />
              <span>ویرایش شماره</span>
            </div>

            <div className={styles.getCodeInput}>
              <ReactCodeInput
                className={styles.codeInput}
                fields={5}
                onChange={onChangeCode}
              />
            </div>

            <div className={styles.loginCodeBtn}>
              <button onClick={login}>
                {loader === false ? (
                  <span>ورود</span>
                ) : (
                  <Loader
                    type="TailSpin"
                    color="white"
                    height={30}
                    width={30}
                  />
                )}
              </button>
            </div>
          </div>
        </div>
      ) : (
        <div className={styles.login}>
          <div className={styles.loginBody}>
            <img src={LoginPic} alt="" />

            <div className={styles.loginTitle}>
              <h2>ورود</h2>
            </div>

            <div className={styles.loginInput}>
              <span>شماره تماس:</span>
              <input
                type="number"
                name="phone"
                placeholder="0912xxxxxxx"
                onChange={onChangePhone}
                value={phone}
              />
            </div>

            <div className={styles.loginBtns}>
              <button className={styles.loginBtn} onClick={getCode}>
                {loader === false ? (
                  <span>ورود</span>
                ) : (
                  <Loader
                    type="TailSpin"
                    color="white"
                    height={30}
                    width={30}
                  />
                )}
              </button>

              <button
                className={styles.registerBtn}
                onClick={() => navigate("/register")}
              >
                هنوز ثبت نام نکردی؟
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Login;